import ChangeEmailList from "../changeEmailList"



const Setting=()=>{

    return(<></>)
}

export default Setting